import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';

import InviteCaregiverModal from '../../components/modals/CaregiverShiftActionModals/InviteCaregiverModal';
import { GLOBAL_CALENDAR_SHIFT_TYPES } from '../../constants';
import { showNotification } from '../../redux/notification';
import { isCancelledSlot } from './shiftActionSlots';

const InviteHCPMenuItem = ({ shift }) => {
	const { shiftId, isRecurring, rawShift } = shift.routeData[GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND];
	const [showInviteModal, setShowInviteModal] = useState(false);
	const dispatch = useDispatch();

	if (!shiftId) {
		return null;
	}

	const slots = rawShift.slots.filter((slot) => !isCancelledSlot(slot)).map((slot) => ({ ...slot }));
	const rawStartTime = slots[0] ? slots[0].raw_start_time : null;
	const resourceType = `${shift.shift_resource_type}${shift.shift_specialty ? ` - ${shift.shift_specialty}` : ''}`;
	const title = `Invite ${resourceType}`;

	const handleSendInvitation = (notificationType, message) => {
		dispatch(showNotification(notificationType, message));
		setShowInviteModal(false);
	};

	return [
		<Dropdown.Item
			key="invite-hcp-gs-action-menu-item"
			className="action-menu-item"
			onClick={() => setShowInviteModal(true)}
		>
			Invite {shift.shift_resource_type}
		</Dropdown.Item>,
		showInviteModal && (
			<InviteCaregiverModal
				key="invite-caregiver-modal"
				size="xl"
				onCancel={() => setShowInviteModal(false)}
				onSendInvitation={handleSendInvitation}
				title={title}
				shift={{
					...shift,
					slots,
					resourceType,
					start_time: shift.formatted_start_time,
					end_time: shift.formatted_end_time,
					raw_start_time: rawStartTime
				}}
				shiftId={shiftId}
				isRecurring={isRecurring}
				closeButton
				cancelLabel="Cancel"
				backdropClassName="invite-caregiver-backdrop"
				facilityName={shift.facility_name}
			/>
		)
	];
};

export default memo(InviteHCPMenuItem);
